import { THistoryItem } from '../../types/vital-data';

export const getVitalDataAverage = (data: any, prop: string) =>
  data.reduce((acc: any, measure: any) => +measure[prop] + acc, 0) / data.length;

export const VITAL_DATA_API_TYPES_UTIL = {
  HR: {
    urlPart: 'heart-rate',
    valuesProp: ['bpm'],
    getValues: (data: any) => ({
      last: data[0].bpm,
      average: getVitalDataAverage(data, 'bpm'),
      lastUpdate: data[0].datetime,
    }),
  },
  BLOOD_PRESSURE: {
    urlPart: 'blood-pressure',
    valuesProp: ['systolic', 'diastolic'],
    getValues: (data: any) => ({
      last: { systolic: data[0].systolic, diastolic: data[0].diastolic },
      average: {
        systolic: getVitalDataAverage(data, 'systolic'),
        diastolic: getVitalDataAverage(data, 'diastolic'),
      },
      lastUpdate: data[0].datetime,
    }),
  },
  SYSTOLIC: {
    urlPart: 'blood-pressure',
    valuesProp: ['systolic', 'diastolic'],
    getValues: (data: any) => ({
      last: { systolic: data[0].systolic, diastolic: data[0].diastolic },
      average: {
        systolic: getVitalDataAverage(data, 'systolic'),
        diastolic: getVitalDataAverage(data, 'diastolic'),
      },
      lastUpdate: data[0].datetime,
    }),
  },
  DIASTOLIC: {
    urlPart: 'blood-pressure',
    valuesProp: ['systolic', 'diastolic'],
    getValues: (data: any) => ({
      last: { systolic: data[0].systolic, diastolic: data[0].diastolic },
      average: {
        systolic: getVitalDataAverage(data, 'systolic'),
        diastolic: getVitalDataAverage(data, 'diastolic'),
      },
      lastUpdate: data[0].datetime,
    }),
  },
  CHOLESTEROL: {
    urlPart: 'cholesterol',
    valuesProp: ['cholesterol'],
    getValues: (data: any) => ({
      last: data[0].cholesterol,
      average: getVitalDataAverage(data, 'cholesterol'),
      lastUpdate: data[0].datetime,
    }),
  },
  TEMPERATURE: {
    urlPart: 'body-temperature',
    valuesProp: ['temperature'],
    getValues: (data: any) => ({
      last: data[0].temperature,
      average: getVitalDataAverage(data, 'temperature'),
      lastUpdate: data[0].datetime,
    }),
  },
  GLUCOSE: {
    urlPart: 'glucose',
    valuesProp: ['glucose'],
    getValues: (data: any) => ({
      last: data[0].glucose,
      average: getVitalDataAverage(data, 'glucose'),
      lastUpdate: data[0].datetime,
    }),
  },
  BREATHING_RATE: {
    urlPart: 'breath-rate',
    valuesProp: ['breathRate'],
    getValues: (data: any) => ({
      last: data[0].breathRate,
      average: getVitalDataAverage(data, 'breathRate'),
      lastUpdate: data[0].datetime,
    }),
  },
  OXYGEN_SATURATION: {
    urlPart: 'oxygen-saturation',
    valuesProp: ['oxygenSaturation'],
    getValues: (data: any) => ({
      last: data[0].oxygenSaturation,
      average: getVitalDataAverage(data, 'oxygenSaturation'),
      lastUpdate: data[0].datetime,
    }),
  },
  BMI: {
    urlPart: 'body-measure',
    valuesProp: ['bmi'],
    getValues: (data: any) => ({
      last: data[0].bmi,
      average: getVitalDataAverage(data, 'bmi'),
      lastUpdate: data[0].datetime,
    }),
  },
  COVID_SCORE: {
    urlPart: 'covid-score',
    valuesProp: ['score'],
  },
  WAIST: {
    urlPart: 'waist-circumference',
    valuesProp: ['waistCircumference'],
  },
};

/**
 * Extract values from record based on type
 * @param type type of data
 * @param record record to extract
 */
export function extractValuesFromRecord(
  type: keyof typeof VITAL_DATA_API_TYPES_UTIL,
  record: THistoryItem,
) {
  // @ts-ignore
  return VITAL_DATA_API_TYPES_UTIL[type].valuesProp.map((key: keyof THistoryItem) => record[key]);
}
